string_utils = App.load 'core::utils/string'
dom_utils = App.load 'core::utils/dom'

hot = window.Handsontable # shortcut

# quick helper/utility function
_addClass = (elem, class_name) ->
    class_name = class_name.trim()
    # if it doesn't already have the class, add it
    if elem?.className.indexOf(class_name) is -1 and class_name.length
        elem.className += ' ' + class_name

###
Functions to provide fancy validation handling to custom renderers.

Check the source data for a `_{prop}_validation` attribute. If the value of
`_{prop}_validation.status` is 'error', add a tooltip (using qTip2) to
display the contents of `_{prop}_validation.message`. If not, clear it.
###
fancyValidation = (instance, TD, row, col, prop, value, cellProperties) ->
    validation = instance.getSourceDataAtRow(row)?["_#{prop}_validation"]
    # if `_{prop}_validation` doesn't exist, we can't do anything
    if not validation?
        clearTooltip(TD)
        return

    # if there's an error, we need to show it
    switch validation.status
        when 'invalid'
            position = getTooltipPosition(instance, col)
            createTooltip(TD, 'red', validation.message, position)
            _addClass(TD, 'invalid')

        when 'incomplete'
            position = getTooltipPosition(instance, col)
            createTooltip(TD, 'cream', validation.message, position)
            _addClass(TD, 'incomplete')

        else
            clearTooltip(TD)

# get the position for the tooltip
getTooltipPosition = (instance, col) ->
    # This is sort of a rough way to do determine which way the tooltip should
    # open (a more accurate way would involve checking the width of the columns
    # and comparing the width of the table with the width of the container),
    # but this is much easier and it's close enough for now. We could also do
    # some fancy checking against the scroll position, but nobody's asked for
    # that yet, so why bother. This basically just ensures that at least it's
    # possible to see all the validation messages.

    # The last two columns should have their tooltips open to the left, but
    # only if it's at least the seventh column.
    if col >= 6 and col >= (instance.countCols() - 2)
        return {
            my: 'top right'
            at: 'bottom left'
        }

    # this is the default
    return {
        my: 'top left'
        at: 'bottom right'
    }


# function to create tooltips
createTooltip = (elem, color, msg, position) ->
    if not msg
        msg = 'There was an unexpected problem with this cell'

    $(elem).qtip
        content:
            text: msg # may be a function that returns a Promise
        position: position
        show:
            ready: false # don't show immediately
            event: 'mouseenter click'
            solo: true # hide all others when showing
        hide:
            # TODO: figure how to hide while editing the cell
            event: 'mouseleave'
            delay: 3000 # wait 3s before hiding
            effect: ->
                $(this).fadeOut()
        events:
            render: ->
                # hack to hide when clicking on the tooltip itself
                # @ is a jQuery object wrapping the tooltip
                @on 'click', ->
                    $(elem).qtip('hide')
        style:
            classes: "qtip-#{color} qtip-rounded qtip-shadow hdt-qtip"

    # Add event listener specific to add/edit product
    $(elem).closest('.hdt-hot').scroll () =>
        if dom_utils.isVerticallyVisibleWithin(elem, '.hdt-hot')
            $(elem).qtip('reposition')
        else
            $(elem).qtip('hide')

    # Add event listener specific to ratings
    $(elem).closest('.handsontable').scroll () =>
        if dom_utils.isVerticallyVisibleWithin(elem, '.handsontable')
            $(elem).qtip('reposition')
        else
            $(elem).qtip('hide')

showTooltip = (elem) =>
    $(elem).qtip('show')

clearTooltip = (elem) =>
    $(elem).qtip('destroy', true)

refreshAllTooltips = (instance) =>
    # clear all the tooltips
    elems = $(instance.rootElement).find('td')
    clearTooltip(elems)

    # then re-create them
    data = instance.getData()
    for row_data, row in data
        for col in [0..(instance.countCols() - 1)]
            prop = instance.colToProp(col)
            fancyValidation(
                instance
                instance.getCell(row, col)
                row
                col
                prop
                row_data[prop]
                instance.getCellMeta(row, col)
            )

hideAllTooltips = (instance) =>
    elems = $(instance.rootElement).find('td')
    $(elems).qtip('hide')

# register all the `validatedWhatever` renderers
known_cell_types = [
    'text'
    'numeric'
    'checkbox'
    'date'
    'select'
    'dropdown'
    'autocomplete'
    'password'
    'handsontable'
    'status' # status is a custom cell type but should already be defined
]
for renderer in known_cell_types
    # create the name of the new renderer
    validated_renderer = 'validated' + string_utils.capitalize(renderer)

    # need `do` to protect the value of `renderer` for the callback
    do (renderer) ->
        hot.renderers.registerRenderer validated_renderer, (params...) ->
            # Note: `this` is the Handsontable instance

            # run base renderer
            hot.renderers.getRenderer(renderer).apply(this, params)

            # apply fancy validation
            fancyValidation.apply(this, params)


# Hack for paste and autofill events so that all cells validate properly. This
# is needed because Handsontable doesn't create the cell or row object until
# after validation finishes, but we need to create a tooltip on the cell if it
# was invalid.
hot.hooks.add 'afterChange', (changes, source) ->
    # @ is the Handsontable instance
    if source in ['paste', 'autofill']
        for change, i in changes
            if change?.length isnt 4
                continue

            [row, prop, old_val, val] = change

            cellProperties = @getCellMeta(row, @propToCol(prop))
            @validateCell val, cellProperties, () =>
                # don't need to do anything with the result
                undefined

    # FOR GOD'S SAKE, DON'T FORGET TO RETURN `changes`!!!!!
    # (Hint: it will break any other afterChange handlers)
    return changes

# hack to fix weird things with the tooltips when removing rows
# TODO: this is still behaving weirdly - some tooltips aren't being recreated
hot.hooks.add 'afterRemoveRow', (row_start, amount) ->
    # @ is the Handsontable instance
    # wait under the re-render finishes before redoing the tooltips
    setTimeout =>
        refreshAllTooltips(this)

# hook to show tooltip when a cell is selected
hot.hooks.add 'afterSelectionEndByProp', (row_start, col_start, row_end, col_end) ->
    # @ is the Handsontable instance
    # only show for single-cell selections
    if row_start is row_end and col_start is col_end
        hideAllTooltips(this)
        showTooltip(@getCell(row_start, col_start))
